<template>
  <div
    class="song-info"
    v-if="song"
  >
    <div class="song-info__table">
      <div class="song-info__left-column">
        <div class="song-info__top">
          <div class="song-info__info-container">
            <div class="song-info__song-title">
              {{song.name}}
            </div>
            <div
              class="song-info__song-name"
              @click="()=>{goToArtistSite(song.artists[0].id)}"
            >
              {{song.artists[0].name}}
            </div>
          </div>
          <div class="song-info__photo-container">
            <div
              class="song-info__photo"
              v-bind:style="{ backgroundImage: 'url(' + artistPhoto + ')' }"
              :class="{photoContentWithoutPhoto: !artistPhoto}"
            >
            </div>
          </div>
        </div>
        <StatisticsSong 
          name="Lista przebojów programu 3" 
          :typeId="1"
          :resultsInfo="resultsInfo"
          />
        <StatisticsSong 
          name="Top wszech czasów" 
          :typeId="2"
          :resultsInfo="resultsInfo"
          />
        <StatisticsSong 
          name="Polski Top Wszech Czasów" 
          :typeId="3"
          :resultsInfo="resultsInfo"
          />
      </div>
      <div class="song-info__right-column">
        <div class="song-info__music">
          <div class="song-info__music-pink-square">

          </div>
          <div class="song-info__music-title">
            wszystkie utwory wykonawcy
          </div>
        </div>
        <div class="song-info__song-list">
          <div
            class="song-info__song"
            v-for="(song, index) in songsList"
            :key="index"
            @click="()=>{goToSong(song.id)}"
          >
            <div class="song-info__song-dot">
            </div>
            <p>{{song.name}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticsSong from './StatisticsSong'
import mixin from '../mixin';

export default {
  mixins: [mixin],
  components: {
    StatisticsSong
  }
}
</script>

<style lang="scss" scoped>
  .song-info {
    width: 100%;
    display: flex;
    justify-content: center;
    border-radius: 5px;
    margin: 2rem 0;
    &__table{
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    &__left-column {
      width: 100%;
      background-color: #fefefe;
      padding: 3rem 1rem 3rem 1rem;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      box-sizing: border-box;
    }
    &__top {
      display: flex;
      justify-content: space-between;
      flex-direction: column-reverse;
      align-items: center;
    }
    &__info-container {
      display: flex;
      flex-direction: column;
      margin-top: 2rem;
    }
    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    &__song-title {
      font-family: 'Poppins', sans-serif;
      color: #0f1626;
      font-size: 2rem;
      font-weight: 700;
      padding-bottom: 0.5rem;
    }
    &__song-name {
      font-family: 'Poppins', sans-serif;
      color: #0f1626;
      font-size: 2rem;
      padding-bottom: 0.5rem;
      cursor: pointer;
      text-align: center;
    }
    &__photo-container{
        width: 100%;
        height: 15rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    &__photo {
      width: 80%;
      height: 100%;
      border: 1px solid #e13368;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100%;
    }
    &__basic-info {
      display: flex;
      justify-content: space-between;
      margin: 2rem auto;
      max-width: 500px;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
    }
    &__first-row {
      display: flex;
      font-size: 1rem;
      font-family: 'Poppins', sans-serif;
      text-transform: uppercase;
      color: #7e7e7e;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      white-space: nowrap;
    }
    &__first-row-one {
      width: 25%;
      display: flex;
      justify-content: center;
      padding: 0.5rem;
    }
    &__first-row-two {
      width: 50%;
      display: flex;
      justify-content: center;
      padding: 0.5rem;
    }
    &__first-row-three {
      width: 25%;
      display: flex;
      justify-content: center;
      padding: 0.5rem;
    }
    &__table-little {
      display: flex;
      font-size: 1.5rem;
      font-family: 'Poppins', sans-serif;
      margin-bottom: 0.2rem;
      flex-wrap: nowrap;
      width: 100%;
      justify-content: space-between;
    }
    &__table-note{
      width: 25%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.6rem;
      border-radius: 3px;
      background-color: #efeeee;
      color: #c574e7;
      font-weight: 700;
    }
    &__table-position{
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.6rem;
      border-radius: 3px;
      background-color: #efeeee;
      font-weight: 700;
      margin: 0 2px;
    }
    &__table-trend{
      width: 25%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.6rem;
      border-radius: 3px;
      background-color: #efeeee;
      font-weight: 700;
    }
    &__symbol {
      height: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      p {
        width: 2rem;
        text-align: center;
      }
    }
    &__symbol-up {
      width: 0;
      height: 0;
      border-left: 0.6rem solid transparent;
      border-right: 0.6rem solid transparent;
      border-bottom: 0.8rem solid #4dc81d;
      margin-left: 0.3rem;
      position: absolute;
      right: -50%;
      transform: translateX(50%);

    }
    &__symbol-zero {
      width: 0.8rem;
      height: 0.8rem;
      background-color: #fbb101;
      border-radius: 100%;
      margin-left: 0.3rem;
      position: absolute;
      right: -50%;
      transform: translateX(50%);
    }
    &__symbol-down {
      width: 0;
      height: 0;
      border-left: 0.6rem solid transparent;
      border-right: 0.6rem solid transparent;
      border-top: 0.8rem solid #df2860;
      margin-left: 0.3rem;
      position: absolute;
      right: -50%;
      transform: translateX(50%);
    }
    &__right-column {
      width: 100%;
      background-color: #28233a;
      padding: 3rem 1rem 1rem 1rem;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      box-sizing: border-box;
    }
    &__music-title {
      color: #d0d0e0;
      text-transform: uppercase;
      font-size: 1.2rem;
      font-family: 'Poppins', sans-serif;
      font-weight: 700;
      padding-bottom: 0.5rem;
    }
    &__song {
      cursor: pointer;
      color: #d0d0e0;
      font-size: 0.9rem;
      font-family: 'Poppins', sans-serif;
      padding-bottom: 1rem;
      display: flex;
      align-items: center;
    }
    &__song-dot {
      width: 0.4rem;
      height: 0.4rem;
      background-color: #d0d0e0;
      border-radius: 100%;
      margin-right: 1rem;
    }
    &__music {
      display: flex;
      margin-bottom: 2rem;
    }
    &__music-pink-square {
      width: 1rem;
      height: 1rem;
      background-color: #df2860;
      margin-right: 1rem;
    }
    &__song:hover {
      color: #df2860;
    }
    .photoContentWithoutPhoto {
      background-image: url('/img/zaslepa.jpg') !important;
    }
  }
</style>
